module.exports = "/images/vendor/jquery-ui-dist/ui-icons_cc0000_256x240.png?a45290aa38c0848e8be2f98552f5a75d";